import { createFileRoute } from "@tanstack/react-router";
import { HolidayAddPage } from "@/site/pages/holidays";

// Old app's holiday browser ("Holiday Reminders") — keep the URL.
export const Route = createFileRoute("/reminders_/holiday_/add")({
  component: HolidayAddPage,
});
